"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUniqueId = void 0;

var _validateProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty");

var validateUniqueId = function validateUniqueId(property) {
  var isValidProperty = typeof property === 'string' && property.length > 0;
  return (0, _validateProperty.validateProperty)(isValidProperty, "expected uniqueId to be a non-empty string but got " + property, 'uniqueId');
};

exports.validateUniqueId = validateUniqueId;